import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, DiscountModel } from 't4core';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { NavigationService } from 'app-components';



@Component({
  selector: 'app-invite-friend-screen',
  templateUrl: './invite-friend-screen.component.html',
  styleUrls: ['./invite-friend-screen.component.css'],
    standalone: false
})
export class InviteFriendScreenComponent extends ComponentBase implements OnInit {

  @Input() public showInvite: boolean = false;
  @Input() public expandWidth: boolean = false;
  @Input() public isCustomerContext: boolean = true;
  @Input() public discounts: DiscountModel;
  public hasActiveCampaign: boolean = false;
  public discount: DiscountModel;
  public discountModel: DiscountModel;
  public title: string;
  public loading: boolean = false;

  constructor(private appIntegrationService: AppIntegrationService, private navigator: NavigationService, public appSettings: AppSettingsService) {
    super();
  }

  async ngOnInit() {
    this.loading = true;
    if (this.discounts) {
      this.discount = this.discounts;
    }
    else {
      this.discount = await this.Api.get<DiscountModel>("/Campaign/CheckActiveInviteFriendsCampaign", { triggerAction: 2, isCustomerContext: this.isCustomerContext, bookingId: this.navigator.getParam('rentalId') });//trigger enum return is set as value 2.
    }    
    this.hasActiveCampaign = this.discount.IsInviteFriendsCampaign;
    this.title = await this.Translate.translate(this.discount.Title, '');
    this.loading = false;
  }

  public async recieveClickOfferAction(action: string) {
    if (this.discount.NoCompetitionCampaign) {
      this.loading = true;
      if (this.discount.DiscountId) {
        this.discountModel = this.discount;
      }
      else {
        this.discountModel = await this.Api.get<DiscountModel>("/Campaign/GenerateCouponForInviteFriend", { isCustomerContext: this.isCustomerContext, bookingId: this.navigator.getParam('rentalId') });
      }
      var messageContent = await this.Translate.translate(this.discountModel.MessageContent, '');
      var messageHeader = await this.Translate.translate(this.discountModel.MessageContentHeader, '');
      this.loading = false;

      setTimeout(() => this.openOffer(messageHeader, messageContent), 0);
      //this.openOffer();
    }
    else {
      this.navigator.executeCommand(action, { rentalId: this.navigator.getParam('rentalId') });
    }
  }

  openOffer(messageHeader: string, messageContent: string) {
    const APP_URLS = {
      use4free: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.kanleiesandroid',
        ios: 'https://apps.apple.com/us/app/use4free/id1612470972',
        default: 'https://www.use4free.se/se/boka-online'
      },
      tysse_utleie: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.androidTysseRental',
        ios: 'https://apps.apple.com/us/app/tysse/id6479396425',
        default: 'https://tysse.no/utleie/bestillonline'
      },
      "24rental_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.android24rental',
        ios: 'https://apps.apple.com/us/app/24rental/id1561167227',
        default: 'https://www.24rental.se/boka-online'
      },
      brenderuprental: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgandroid',
        ios: 'https://apps.apple.com/us/app/brenderup-rental/id1572540717',
        default: 'https://www.brenderuprental.com/se/boka-slap'
      },
      "okq8_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.okq8trailerandroid',
        ios: 'https://apps.apple.com/us/app/okq8-sl%C3%A4p/id1548277008',
        default: 'https://www.use4free.se/se/boka-online'//Need to get the proper url for okq8 slap 
      },
      maxbo: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgmaxbo',
        ios: 'https://apps.apple.com/us/app/maxbo-tilhenger/id1619084804',
        default: 'https://www.maxbo.no/tjenester/utleie-tilhenger/'
      }
    };

    let appUrl = '';
    var device = this.getMobileOperatingSystem();
    const themeKey = this.appSettings.settings.theme.toLowerCase().replace(/[^a-z0-9]/gi, '_');
    if (APP_URLS[themeKey]) {
      if (device == 'Android') {
        appUrl = APP_URLS[themeKey].android;
      } else if (device == 'iOS') {
        appUrl = APP_URLS[themeKey].ios;
      } else {
        appUrl = APP_URLS[themeKey].default;
      }
    } else {
      appUrl = 'https://www.use4free.se/se';
    }

    var message = messageContent;
    message = message.replace("**CODE**", this.discountModel.DiscountId);
    

    if (device == 'Android') {
      this.appIntegrationService.shareOffer(message + appUrl);
    } else if (navigator.share) {
      navigator.share({
        title: '🚛 ' + messageHeader,
        text: message,
        url: appUrl
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch((error) => {
        console.error('Error sharing:', error);
      });
    } else {
      console.log('Sharing not supported');
    }
  }

  public getMobileOperatingSystem(): string {
    var userAgent = navigator.userAgent || navigator.vendor;

    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    var win: any = window;
    if (/iPad|iPhone|iPod/.test(userAgent) && !win.MSStream) {
      return "iOS";
    }

    return "unknown";
  }
}
